"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopilotSetting = exports.getCopilotSetting = void 0;
const react_1 = __importDefault(require("react"));
const schemaComponents_1 = require("@/schemaComponents");
const hooks_1 = require("common/hooks");
const react_tooltip_1 = require("react-tooltip");
const localStorageKey = "personalData";
const defaultSeetting = {
    ignoreExactMatchedReference: false,
    translationModel: "gpt-4o",
    proofreadingModel: "gpt-35-turbo",
};
const getCopilotSetting = () => {
    var _a, _b, _c;
    const setting = localStorage.getItem(localStorageKey);
    const data = (setting ? JSON.parse(setting) : {});
    return {
        ignoreExactMatchedReference: (_a = data.ignoreExactMatchedReference) !== null && _a !== void 0 ? _a : defaultSeetting.ignoreExactMatchedReference,
        translationModel: (_b = data.translationModel) !== null && _b !== void 0 ? _b : defaultSeetting.translationModel,
        proofreadingModel: (_c = data.proofreadingModel) !== null && _c !== void 0 ? _c : defaultSeetting.proofreadingModel,
    };
};
exports.getCopilotSetting = getCopilotSetting;
function CopilotSetting() {
    const [personalData, setPersonalData] = (0, hooks_1.useLocalStorage)(localStorageKey, {
        ignoreExactMatchedReference: false,
        translationModel: null,
        proofreadingModel: null,
    });
    const editModeEnabled = true;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "sidePanelTitle" }, "\u7FFB\u8A33\u8A2D\u5B9A"),
        react_1.default.createElement("div", { style: { padding: "10px" } },
            react_1.default.createElement(react_tooltip_1.Tooltip, { id: "tooltip", style: { zIndex: 1000 } }),
            react_1.default.createElement(schemaComponents_1.SchemaInput, { onValueChange: (value) => {
                    setPersonalData(value);
                }, data: personalData, schema: {
                    schemaType: "object",
                    properties: [
                        {
                            propertyName: "translationModel",
                            title: "翻訳モデル",
                            tooltip: "翻訳時に利用される言語モデルを指定します",
                            schema: {
                                schemaType: "selector",
                                uiType: "normal",
                                options: [
                                    {
                                        value: null,
                                        title: `デフォルト(${defaultSeetting.translationModel})`,
                                    },
                                    {
                                        value: "gpt-4o",
                                        title: "通常(gpt-4o)",
                                    },
                                    {
                                        value: "gpt-35-turbo",
                                        title: "高速(gpt-35-turbo)",
                                    },
                                ],
                            },
                        },
                        {
                            propertyName: "proofreadingModel",
                            title: "校閲モデル",
                            tooltip: "校閲時に利用される言語モデルを指定します",
                            schema: {
                                schemaType: "selector",
                                uiType: "normal",
                                options: [
                                    {
                                        value: null,
                                        title: `デフォルト(${defaultSeetting.translationModel})`,
                                    },
                                    {
                                        value: "gpt-4o",
                                        title: "通常(gpt-4o)",
                                    },
                                    {
                                        value: "gpt-35-turbo",
                                        title: "高速(gpt-35-turbo)",
                                    },
                                ],
                            },
                        },
                        {
                            propertyName: "ignoreExactMatchedReference",
                            title: "完全一致する参照訳を無視する",
                            tooltip: "翻訳時に、完全一致する参照訳がある場合、通常はその訳が採用されますが、これだと翻訳の評価がしづらくなります。オンにすると完全一致する参照訳を無視して、それ以外の訳をもとに翻訳を行います。この設定は、ブラウザごとに保存されるため、異なるブラウザには反映されません。",
                            schema: {
                                schemaType: "boolean",
                            },
                        },
                    ],
                } }))));
}
exports.CopilotSetting = CopilotSetting;
